<div class="app-page" style="margin: auto; padding: 0; min-height: 400px; font-family: Rubik, Verdana, sans-serif;">
  <mat-toolbar>
    <button mat-icon-button (click)="openSetGameFilterDialog()">
      <mat-icon>filter_alt</mat-icon>
    </button>
    <button matButton="tonal" (click)="getPastGames()">
      <mat-icon>event_repeat</mat-icon>
      {{ 'GAMES.PAST' | translate | uppercase }}
    </button>
    <button matButton="tonal" (click)="getData()">
      <mat-icon>event</mat-icon>
      {{ 'GAMES.COMING' | translate | uppercase }}
    </button>
    <!-- Timezone Menu Button -->
    <button mat-button [matMenuTriggerFor]="timezoneMenu" aria-label="Select timezone">
      {{ timezoneText() | uppercase }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #timezoneMenu="matMenu">
      <button mat-menu-item (click)="toggleTimezone('GameTimeUTC')">{{ 'TIMEZONE.MY_TIMEZONE' | translate | uppercase }}</button>
      <button mat-menu-item (click)="toggleTimezone('GameDate')">{{ 'TIMEZONE.LOCAL_TIMEZONES' | translate | uppercase }}</button>
    </mat-menu>
  </mat-toolbar>

  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (_pageData().Games.length === 0 && !isLoading()) {
    <div style="margin: 20px; text-align: center;">
      {{ 'GAMES.NOGAMESFOUND' | translate | uppercase }}
    </div>
  }
  @if (isLoading()) {
    <div style="margin: 20px; text-align: center;">
      {{ 'GENERAL.LOADING' | translate | uppercase }}...
    </div>
  }

  @if (_pageData().Games.length > 0) {
    <div class="content-container">
      @for (group of _pageData().Games | groupByDateAndDivision: GroupByPropertyName() : useLocalTimezone(): sort(); track group.GroupDate) {
        <!-- Date Divider -->
        <div class="date-divider">
          <div class="date-text">
            {{ group.GroupDate | date: 'dd' }} {{ group.GroupDate | date: 'MMM' }}
            <br>
              <span class="day-text">{{ group.GroupDate | date: 'EEE' }}</span>
            </div>
          </div>
          <!-- Divisioner -->
          @for (division of group.Divisions; track division.DivisionName) {
            <!-- Division Header -->
            <div class="division-header">
              {{ division.DivisionName }}
            </div>
            <!-- Games Table -->
            <mat-table [dataSource]="division.Games" class="mat-elevation-z2">
              <ng-container matColumnDef="matchDetails">
                <mat-cell *matCellDef="let game" class="match-details">
                  <div class="match-details-content">
                    <div class="team-cell home-team">
                      <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)"
                        style="text-decoration: none; color: inherit; display: block; height: 40px; padding-top: 20px;">
                        {{ game.HomeTeamName || 'No Home Team' }}
                      </a>
                    </div>
                    <div style="padding: 0 10px; width: 40px;">
                      <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)"
                        style="text-decoration: none;  color: inherit;/">
                        <img [src]="game.HomeTeamSmallIcon ? getIconPath(game.HomeTeamSmallIcon) : '/assets/images/placeholder.png'"
                          style="width: 40px; height: 40px; object-fit: contain;"
                          (error)="handleImageError($event)"
                          alt="Home Team Icon">
                        </a>
                      </div>
                      <div style="text-align: center; padding: 0 10px; width: 70px;">
                        <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)" 
                          style="text-decoration: none; color: inherit; display: block; height: 40px; padding-top: 20px;">
                          {{ (GroupByPropertyName() === 'GameTimeUTC' ? game.GameTimeUTC : game.GameTime) | date: 'HH:mm' }}
                        </a>
                      </div>
                      <div style="padding: 0 10px; width: 40px;">
                        <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)"
                          style="text-decoration: none;  color: inherit;">
                          <img [src]="game.AwayTeamSmallIcon ? getIconPath(game.AwayTeamSmallIcon) : '/assets/images/placeholder.png'"
                            style="width: 40px; height: 40px; object-fit: contain;"
                            (error)="handleImageError($event)"
                            alt="Away Team Icon">
                          </a>
                         
                        </div>
                        <div class="team-cell away-team">
                          <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)"
                            style="text-decoration: none; color: inherit; display: block; height: 40px; padding-top: 20px;">
                            {{ game.AwayTeamName || 'No Away Team' }}
                          </a>
                        </div>
                        <!-- Add to Schedule button -->
                        <button mat-icon-button (click)="addToSchedule(game.GameId, game.HomeTeamName, game.AwayTeamName, game.GameDate, game.GameTime)"
                          class="action-button">
                          <mat-icon fontIcon="calendar_add_on"  fontSet="material-icons-outlined"></mat-icon>
                          <span class="material-symbols-outlined">
                            calendar_add_on
                          </span>
                        </button>
                      </div>
                    </mat-cell>
                  </ng-container>
                  <mat-row *matRowDef="let row; columns: ['matchDetails']"
                    [ngClass]="{'past-game': pastGamesActive(), 'coming-game': !pastGamesActive()}"
                  style="border-left: 4px solid #2196f3; height: 56px;"></mat-row>
                </mat-table>
              }
            }
          </div>
        }
      </div>